<template>
  <div class="map-right-layers-component map-right-layers-component__container">
    <CollapseLateral
      id="lateral__collapse__layers--capas"
      text-tooltip="Agregar capas"
      orientation="down-left"
      autoclose
      class="map-right-layers-component__collapse-lateral"
    >
      <template #icon>
        <span class="material-icons">
          layers
        </span>
      </template>
      <template #title>
        <h4>Agregar capas</h4>
      </template>
      <div class="map-right-layers-component__collapse-lateral__content">
        <div
          class="map-right-layers-component__collapse-lateral__content__row-actions"
        >
          <span
            v-for="(item, index) in rowButtons"
            :key="index"
            v-tooltip.bottom="item.tooltip"
            class="
              map-right-layers-component__collapse-lateral__content__row-actions__button
              material-icons
            "
            @click="item.onClick"
          >
            {{ item.icon }}
          </span>
        </div>
        <div class="map-right-layers-component__collapse-lateral__content__tab-view">
          <TabView
            :active-index="state$$.tabView.itemActive"
            @tab-change="onChangeTab"
          >
            <TabPanel header="Archivos">
              <div
                class="
                  map-right-layers-component__collapse-lateral__content__tab-view__archivos
                "
              >
                <div
                  v-for="
                    (item, index) of
                      GROUP_DRAW.getLayers()?.getArray()[0]?.getSource().getFeatures()
                  "
                  :key="item.ol_uid"
                >
                  <MapRightLayersItemFeature
                    :feature="item"
                    @click-delete="() => deleteFeature(index)"
                    @new-name="(name) => newNameFeature(index, name)"
                  />
                </div>
              </div>
            </TabPanel>
            <TabPanel header="Servicios">
              <div
                v-for="(item, index) of GROUP_SERVICES.getLayers().getArray()"
                :key="item.getProperties().name + index"
              >
                <MapRightLayersItemServices
                  :layer="item"
                  @click-delete="() => deleteService(index)"
                />
              </div>
            </TabPanel>
          </TabView>
        </div>
      </div>
    </CollapseLateral>
    <Dialog
      v-model:visible="state$$.modal.show"
      class="map-right-layers-component__dialog"
      content-class="map-right-layers-component__dialog__content"
      header="Agregar archivos o servicios"
      :breakpoints="{'960px': '75dvw', '640px': '90dvw'}"
      :style="{width: '50dvw'}"
      :modal="true"
    >
      <TabView
        :active-index="state$$.tabView.itemActive"
        class="map-right-layers-component__dialog__content__tab-view"
        @tab-change="onChangeTab"
      >
        <TabPanel
          header="Archivos"
        >
          <div class="map-right-layers-component__dialog__content__tab-view__tab-panel">
            <MapRightAddFiles
              :files="filesRef"
              @new-file="onAddNewFile"
              @update-files="onUpdateFiles"
            />
          </div>
        </TabPanel>
        <TabPanel
          header="Servicios"
        >
          <div class="map-right-layers-component__dialog__content__tab-view__tab-panel">
            <ItemService
              v-for="id in servicesRef"
              :id="id"
              :key="id"
              @confirmed="onConfirmedService"
              @click-delete="onClickDeleteService"
            />
            <Button
              v-if="state$$.tabView.canAddServices"
              label="Nuevo servicio"
              @click="addService"
            />
          </div>
        </TabPanel>
      </TabView>
      <template #footer>
        <Button
          :disabled="!state$$.tabView.canClickAccept"
          label="Aceptar"
          @click="addServicesAndFiles"
        />
      </template>
    </Dialog>
  </div>
</template>


<script setup>
// vue
import {reactive, ref, onMounted, inject} from 'vue';

// sttedra
import {CollapseLateral} from '@sttedra_ui/framework';

// Primevue
import TabView from 'primevue/tabview';
import TabPanel from 'primevue/tabpanel';
import Dialog from 'primevue/dialog';
import Button from 'primevue/button';

// config
import state from './map-right.layers.component-state';
import getAllLayersFromCapabilities from '../../getAllLayersFromCapabilities';
import {STYLE_DEFAULT} from '../../styles.config-styles';

// components
import ItemService from './MapRight-Layers.Item-Services';
import MapRightLayersItemServices from './MapRight.Layers.Item-Services.List';
import MapRightLayersItemFeature from './MapRight.Layers.Item-Feature';
import MapRightAddFiles from './MapRight.Layers.AddFiles';

// openlayers
import {Group as LayerGroup} from 'ol/layer';
import Collection from 'ol/Collection';
import {GeoJSON, KML, GML} from 'ol/format';
import {Vector as VectorSource} from 'ol/source';
import {Vector as VectorLayer} from 'ol/layer';

// composables
import randomString from '@/composables/random-string/random-string';

// Composables
import readFile from '@/composables/readFile/readFile';
// #region Props, Emits
// ...
// #endregion


// #region Params, Ref, Reactives, Computed
const state$$ = reactive(state);
const servicesRef = ref([]);
const filesRef = ref([]);
const itemsServicesValuesRef = ref([]);

const GROUP_SERVICES = inject('GROUP_SERVICES');
const GROUP_DRAW = inject('GROUP_DRAW');

const SOURCE_VECTOR = reactive(new VectorSource());
const VECTOR_LAYER = new VectorLayer({source: SOURCE_VECTOR, style: STYLE_DEFAULT});

const rowButtons = [
  {
    onClick: openModal,
    tooltip: 'Cargar archivos o servicios',
    icon: 'file_upload',
  },
  {
    onClick: removeAll,
    tooltip: 'Borrar todo el contenido',
    icon: 'delete_outline',
  },
];
// #endregion


// #region Functions
function updateState(values) {
  Object.keys(values).forEach((key) => {
    if (state$$[key] !== undefined) {
      if (state$$[key] instanceof Object && !Array.isArray(state$$[key]) ) {
        state$$[key] = {...state$$[key], ...values[key]};
      } else {
        state$$[key] = values[key];
      }
    }
  });
}

function onAddNewFile(file) {
  filesRef.value.push(file);
  updateCanClickAccept();
}

function onUpdateFiles(files) {
  filesRef.value = files;
  updateCanClickAccept();
}

/**
 * Function to open the modal
 *
 */
function openModal() {
  const modal = state$$.modal;
  modal.show = true;
  state$$.tabView.canClickAccept = false;
  filesRef.value = [];
  servicesRef.value = [
    randomString(),
  ];
  updateState({modal});
}

/**
 * Function to set new service
 *
 */
function addService() {
  servicesRef.value.push(randomString());
}

/**
 * Event when a tab has been changed
 *
 * @param {Event} event
 *
 */
function onChangeTab(event) {
  const tabView = state$$.tabView;
  tabView.itemActive = event.index;
  updateState({tabView});
}

/**
 * Event when a service has been confirmed
 *
 * @param {Object} item
 *
 */
function onConfirmedService(item) {
  const itemExtists = itemsServicesValuesRef.value.find((service) => {
    return service.id === item.id;
  });

  if (itemExtists) {
    itemsServicesValuesRef.value.forEach((service) => {
      if (service.id === item.id) {
        service = item;
      }
    });
  } else {
    itemsServicesValuesRef.value.push(item);
  }

  checkAllServicesValid();
}

/**
 * Event when a service has been confirmed
 *
 * @param {Object} item
 *
 */
function onClickDeleteService(item) {
  // Se comprueba si existe el item
  const itemExtists = itemsServicesValuesRef.value.find((service) => {
    return service.id === item.id;
  });

  // Si no existe el item se añade
  if (!itemExtists) {
    itemsServicesValuesRef.value.push(item);
  }

  // Se busca la posición que ocupa el item
  let position = null;
  let index = 0;
  servicesRef.value.forEach((serviceId) => {
    if (serviceId === item.id) {
      position = index;
    }
    index++;
  });

  // Se elimina del array
  if (position !== null) {
    servicesRef.value.splice(position, 1);
  }

  // Si no hay items añadidos se añade uno por defecto
  if (servicesRef.value.length <= 0) {
    addService();
  }

  checkAllServicesValid();
}

/**
 * Update the value to show the button add services
 *
 */
function checkAllServicesValid() {
  const tabView = state$$.tabView;
  let allValid = true;
  if (itemsServicesValuesRef.value.length > 0) {
    itemsServicesValuesRef.value.forEach((item) => {
      if (allValid) {
        if (!item.isValid) {
          allValid = false;
        }
      }
    });
  }
  tabView.canAddServices = allValid;
  updateState({tabView});
  updateCanClickAccept();
}

/**
 * Update the value to show the button add services
 *
 */
function checkAllFilesValid() {
  let allValid = filesRef.value.length > 0;
  for (const file of filesRef.value) {
    if (file.coordinateSystem === null) {
      allValid = false;
      break;
    }
  }
  return allValid;
}

/**
 * Check if can click button accept
 *
 */
function updateCanClickAccept() {
  state$$.tabView.canClickAccept = false;
  if (itemsServicesValuesRef.value.length > 0 || checkAllFilesValid()) {
    state$$.tabView.canClickAccept = true;
  }
}

/**
 * Add a new service or files to the layers
 *
 */
async function addServicesAndFiles() {
  itemsServicesValuesRef.value.forEach(async (service) => {
    const layers = await getAllLayersFromCapabilities(service);
    if (layers) {
      const layerGroup = new LayerGroup({
        layers,
        properties: {
          name: service.nameService,
        },
      });
      GROUP_SERVICES.setLayers(
        new Collection([...GROUP_SERVICES.getLayers().getArray(), layerGroup]),
      );
    }
  });
  filesRef.value.forEach(async (file) => {
    const {result} = await readFile(file);
    let parser = null;
    if (file.name.includes('.geojson') || file.name.includes('.json')) {
      parser = new GeoJSON();
    } else if (file.name.includes('.kml')) {
      parser = new KML();
    } else if (file.name.includes('.gml')) {
      parser = new GML();
    }
    if (parser) {
      const featuresDraw = parser.readFeatures(result, {
        dataProjection: file.coordinateSystem.name,
        featureProjection: 'EPSG:25830',
      });
      featuresDraw.forEach((feature) => {
        feature.setStyle(STYLE_DEFAULT);
      });
      GROUP_DRAW.getLayers().getArray()[0].getSource().addFeatures(featuresDraw);
    }
  });
  itemsServicesValuesRef.value = [];
  servicesRef.value = [];
  state$$.modal.show = false;
}

/**
 * Remove a service
 *
 * @param {Integer} index
 *
 */
function deleteService(index) {
  const layer = GROUP_SERVICES.getLayers().getArray().splice(index, 1);
  layer[0].setVisible(false);
}

/**
 * Remove a feature
 *
 * @param {Integer} index
 *
 */
function deleteFeature(index) {
  const feature = GROUP_DRAW.getLayers().getArray()[0].getSource().getFeatures().splice(index, 1);
  GROUP_DRAW.getLayers().getArray()[0].getSource().removeFeature(feature[0]);
}

/**
 * Remove a feature
 *
 * @param {Integer} index
 *
 */
function newNameFeature(index, name) {
  const features = GROUP_DRAW.getLayers().getArray()[0].getSource().getFeatures();
  for (let i = 0; i < features.length; i++ ) {
    if (i === index) {
      features[i].setProperties({name});
      break;
    }
  }
  console.log('change name', features);
}

/**
 * Remove all the features and services
 *
 */
function removeAll() {
  GROUP_DRAW.getLayers().getArray()[0].getSource().getFeatures().forEach((feature) => {
    GROUP_DRAW.getLayers().getArray()[0].getSource().removeFeature(feature);
  });
  GROUP_SERVICES.setLayers(new Collection([]));
}
// #endregion


// #region Effects, Hooks
// ...
// #endregion
// #region Effects, Hooks
onMounted(() => {
  GROUP_DRAW.setLayers(new Collection([VECTOR_LAYER]));
});


// #region Provide, Expose
// ...
// #endregion
</script>


<style lang="scss" scoped>
.map-right-layers-component {
  & #lateral__collapse__layers--capas {
    display: none;
  }
  &__dialog {
    z-index: 999;
  }
  &__collapse-lateral {
    &__content {
      &__row-actions {
        margin-top: 5px;
        margin-bottom: 5px;
        display: flex;
        justify-content: flex-end;

        &__button {
          border: 1px solid black;
          border-radius: 100%;
          cursor: pointer;
          width: 25px;
          height: 25px;
          display: flex;
          justify-content: center;
          align-items: center;
          margin-left: 5px;
        }
      }

      &__tab-view {
        &__archivos {
          max-height: 300px;
          overflow: auto;
        }
      }
    }


  }
}

</style>

<style>
.map-right-layers-component__dialog__content {
  min-height: auto !important;
  padding: 1rem !important;
}
</style>
